import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
    Grid,
    Typography,
    Collapse,
    Icon
} from "@mui/material";

import SearchInput from 'Components/SearchInput';
import { Loading, Checkbox, LinearProgress, Button, Chip, Tooltip } from "@gpstrackit/react-controls";
import { useIntl } from 'react-intl';
import { getTagColor, getDataForEntityTags } from 'Core/data/Helpers';
import { Waypoint } from "react-waypoint";
import cx from 'classnames';

// Styles
import './styles.scss';
// Actions
import {
    entityTagPickerSearchEnityTags,
    searchEntityRequest,
    clearRedux
} from 'Redux/actions';

const EntityTagPicker = (props) => {
    // Props
    const { messages } = useIntl();

    const {
        entity,
        height,
        value,
        showUntagged = true,
        disableUntaggedSelection = false,
        disableTagSelection = true,
        onlyValueId = true,
        showSelectedItemsBelow = false,
        multiple = true,
        onlyTagsWithEntities = false,
        title,
        required
    } = props;

    const dispatch = useDispatch();

    const user = useSelector(state => state.securityRedux.user);
    const entityTags = useSelector(state => state.entityTagPickerRedux.entityTags);
    const loadingEntityTags = useSelector(state => state.entityTagPickerRedux.loadingEntityTags);
    const filters = useSelector(state => state.entityTagPickerRedux.filters);

    const units = useSelector(state => state.generalRedux.units);
    const loadingUnits = useSelector(state => state.generalRedux.loadingEntity);
    const accounts = useSelector(state => state.generalRedux.accounts);
    const loadingAccounts = useSelector(state => state.generalRedux.loadingEntity);
    const tags = useSelector(state => state.generalRedux.tags);

    const [searchText, setSearchText] = useState("");
    const [expanded, setExpanded] = React.useState([]);
    const [result, setResult] = React.useState([]);

    const expand = useCallback((id) => {
        let newExpanded = [...expanded];
        if (expanded.includes(id)) {
            newExpanded = expanded.filter(e => e != id);
        } else {
            newExpanded.push(id);
        }

        setExpanded(newExpanded);
    });

    const renderLevel = (id, indent = 0, collapse, parentdHeight = 0) => {
        let newEntityTags = {};
        if (entityTags[entity]) {
            newEntityTags = { ...entityTags[entity] };
        }

        let newLoadingEntityTags = {};
        if (loadingEntityTags[entity]) {
            newLoadingEntityTags = { ...loadingEntityTags[entity] };
        }

        let newFilters = {};
        if (filters[entity]) {
            newFilters = { ...filters[entity] };
        }

        //if (!user.isSubUser && id === 0 && newEntityTags[0] && !newEntityTags[0].find(et => et.id === -1) && showUntagged) {
        //if (newEntityTags[0] && !newEntityTags[0].find(et => et.id === -1) && showUntagged) {
        //    newEntityTags[0].unshift({ id: -1, name: "Tag", label: messages['entityTagPicker_untagged'] });
        //}

        let childHeight = (newEntityTags[id]?.length * 40) + 20;
        if (childHeight > 250) childHeight = 250;
        parentdHeight += childHeight
        if (parentdHeight > 250) parentdHeight = 250;

        return (
            <div
                style={{ maxHeight: height || 250, overflow: 'hidden auto' }}
            >
                {
                    (newEntityTags[id] && newEntityTags[id]?.length > 0) && newEntityTags[id]?.map((item, index) => {
                        let hasEntities = false;
                        if (item.name === "Tag") {
                            if (entity === "Unit") {
                                hasEntities = item?.tag?.unitsCount > 0;
                            } else if (entity === "Company") {
                                hasEntities = item?.tag?.companiesCount > 0;
                            } else {
                                hasEntities = item?.tag?.entitiesCount > 0;
                            }
                        }

                        let checked = value.includes(`${item?.id}`) ||
                            value.includes(parseInt(item?.id)) ||
                            (value.find(selectedItem => selectedItem?.id == item?.id && selectedItem?.name === item?.name) ? true : false);

                        let disabled = item?.disabled || (disableUntaggedSelection && item.id == -1) || (item.name === "Tag" && !hasEntities) ? true : false;

                        if (!multiple && value?.length && !checked) {
                            disabled = true;
                        }

                        if (disabled && item.id == -1) return <span></span>

                        return (
                            <React.Fragment key={index}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    wrap="nowrap"
                                    style={{
                                        padding: '5px 0px 5px 0px',
                                        paddingLeft: indent
                                    }}
                                >
                                    <Grid item style={{ display: 'flex ', alignItems: 'center', width: 30, height: 30 }}>
                                        {
                                            (item?.id === -1 || (item.name === "Tag" && (item?.tag?.hasChildren || hasEntities))) &&
                                            <React.Fragment>
                                                {
                                                    newLoadingEntityTags[item.id] ?
                                                        <div style={{ paddingTop: 7, paddingLeft: 7 }}><Loading size={18} /></div> :
                                                        <Icon
                                                            disabled={newLoadingEntityTags[id]}
                                                            onClick={(e) => {
                                                                expand(item.id);
                                                                if (!newEntityTags[item.id]) {
                                                                    dispatch(entityTagPickerSearchEnityTags({ parentTagId: item.id, entityName: entity, limit: 25, offset: 0, onlyTagsWithEntities, untaggedAccess: false }));
                                                                }
                                                            }}
                                                            style={{ fontSize: 30, margin: '0px', cursor: 'pointer' }}
                                                        >
                                                            {expanded.includes(item?.id) ? 'arrow_drop_down' : 'arrow_right'}
                                                        </Icon>
                                                }
                                            </React.Fragment>
                                        }
                                    </Grid>

                                    {
                                        ((item.name === "Tag" && !disableTagSelection) || item.name !== "Tag") &&
                                        <Grid item>
                                            <Checkbox
                                                value={checked}
                                                size="sm"
                                                disabled={disabled}
                                                id={`${item?.id}`}
                                                onChange={() => {
                                                    let newSelected = [...value];
                                                    if (!onlyValueId) {
                                                        if (value.find(selectedItem => selectedItem?.id === item?.id && selectedItem?.name === item?.name)) {
                                                            newSelected = value.filter(e => e.id != item.id);
                                                        } else {
                                                            newSelected.push(item);
                                                        }
                                                    } else {
                                                        newSelected = [...value];
                                                        if (value.includes(item.id)) {
                                                            newSelected = value.filter(e => e != item.id);
                                                        } else {
                                                            newSelected.push(item.id);
                                                        }
                                                    }

                                                    if (props.onChange) props.onChange(newSelected, entity);
                                                }}
                                                style={{
                                                    marginRight: 0,
                                                    marginLeft: 0
                                                }}
                                            />
                                        </Grid>
                                    }

                                    {
                                        item.name === "Tag" &&
                                        <Grid item style={{ display: 'flex ' }}>
                                            <Icon style={{ fontSize: 18, color: `#${getTagColor(item?.color)}`, marginRight: 6 }}>
                                                local_offer
                                            </Icon>
                                        </Grid>
                                    }

                                    <Grid item xs zeroMinWidth>
                                        <Tooltip placement='left-start' title={item?.id == -1 ? messages[item.label] : item.label}>
                                            <Typography noWrap>{item?.id == -1 ? messages[item.label] : item.label}</Typography>
                                        </Tooltip>
                                    </Grid>
                                </Grid>

                                {
                                    (newEntityTags[item?.id] && newEntityTags[item?.id]?.length > 0) &&
                                    <Collapse in={expanded.includes(item?.id)} timeout="auto" unmountOnExit>
                                        {
                                            renderLevel(item?.id, indent + 30, expanded.includes(item?.id), childHeight)
                                        }
                                    </Collapse>
                                }
                            </React.Fragment>
                        )
                    })
                }
                {
                    newEntityTags[id]?.length < newFilters[id]?.total &&
                    <Waypoint onEnter={() => {
                        dispatch(entityTagPickerSearchEnityTags({
                            parentTagId: id,
                            entityName: entity,
                            limit: 25,
                            offset: (newFilters[id]?.offset + newFilters[id]?.limit),
                            onlyTagsWithEntities
                        }));
                    }}>
                        <h5 className="text-muted mt-5">
                            Loading data{" "}
                            <LinearProgress color="primary" />
                        </h5>
                    </Waypoint>
                }
            </div>
            //</InfiniteScroll>
        )
    };

    useEffect(() => {

        if (!entityTags[entity]) {
            dispatch(entityTagPickerSearchEnityTags({ parentTagId: 0, entityName: entity, limit: 25, offset: 0, onlyTagsWithEntities }));
        }

        return () => {
            dispatch(clearRedux('ENTITY_TAG_PICKER'));
        }
    }, []);

    useEffect(() => {
        if (accounts && searchText !== "" && entity === "Company") {
            let data = getDataForEntityTags(entity, accounts, units)

            if (tags?.length) {
                let newTags = tags.map(tag => {
                    return { ...tag, name: "Tag" };
                });

                data = [...data, ...newTags];
            }

            const newResult = data.filter((item) => (item.label.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())));
            setResult(newResult);
        }

        if (units && searchText !== "" && entity === "Unit") {
            let data = getDataForEntityTags(entity, accounts, units)

            if (tags?.length) {
                let newTags = tags.map(tag => {
                    return { ...tag, name: "Tag" };
                });

                data = [...data, ...newTags];
            }

            const newResult = data.filter((item) => (item.label.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())));
            setResult(newResult);
        }
    }, [accounts, units]);

    return (
        <div>
            <div className={cx('mt-10', 'mh-20')}>
                <Typography variant="subtitle2">
                    {title}{required && <span className="text-danger"> *</span>}
                </Typography>
            </div>
            <SearchInput
                placeholder={messages['search']}
                searchText={searchText}
                disabled={(loadingEntityTags[entity] && loadingEntityTags[entity][0])}
                onSearchText={(text) => {
                    setSearchText(text);

                    if (!text) {
                        setResult([]);
                        return;
                    }

                    if (entity === "Company") {
                        dispatch(searchEntityRequest({ key: "accounts", openSearch: text }));
                    } else if (entity === "Unit") {
                        dispatch(searchEntityRequest({ key: "units", openSearch: text }));
                    }

                }}
                Loading={loadingUnits || loadingAccounts}
            />

            {
                searchText ?
                    <div
                        className='entity-tag-picker-container'
                        style={{
                            height: height,
                            overflow: "hidden auto"
                        }}
                    >
                        {
                            !result?.length &&
                            <div style={{ padding: 5, fontSize: 12, color: 'grey', textAlign: "center" }}>
                                {messages['entityTagPicker_noFound']}
                            </div>
                        }

                        {
                            result.map((item, index) => {
                                let disabled = disableTagSelection && item?.name === "Tag" ? true : false;
                                let checked = value.includes(`${item?.id}`) || value.includes(parseInt(item?.id)) || (value.find(selectedItem => selectedItem?.id == item?.id && selectedItem?.name == item?.name) ? true : false);
                                if (!multiple && value?.length && !checked) {
                                    disabled = true;
                                }

                                return (
                                    <Grid
                                        key={index}
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        wrap="nowrap"
                                        style={{
                                            padding: '5px 10px 5px 10px',
                                        }}
                                    >
                                        <Grid item={true}>
                                            <Checkbox
                                                value={checked}
                                                size="sm"
                                                id={`${item?.id}`}
                                                onChange={() => {
                                                    let newSelected = [...value];
                                                    if (!onlyValueId) {
                                                        if (value.find(selectedItem => selectedItem?.id == item?.id && selectedItem?.name == item?.name)) {
                                                            newSelected = value.filter(e => e.id != item.id);
                                                        } else {
                                                            newSelected.push(item);
                                                        }
                                                    } else {
                                                        newSelected = [...value];
                                                        if (value.includes(item.id)) {
                                                            newSelected = value.filter(e => e != item.id);
                                                        } else {
                                                            newSelected.push(item.id);
                                                        }
                                                    }

                                                    if (props.onChange) props.onChange(newSelected, entity);
                                                }}
                                                disabled={disabled}
                                                style={{
                                                    marginRight: 0
                                                }}
                                            />
                                        </Grid>

                                        {
                                            item.name === "Tag" &&
                                            <Grid item style={{ display: 'flex ' }}>
                                                <Icon style={{ fontSize: 18, color: `#${getTagColor(item?.color)}`, marginRight: 6 }}>
                                                    local_offer
                                                </Icon>
                                            </Grid>
                                        }

                                        <Grid item={true} xs zeroMinWidth>
                                            <Typography noWrap>
                                                {item.label}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                    </div> :
                    <div className='entity-tag-picker-container' style={{ height: height }}>
                        {
                            ((loadingEntityTags[entity] && loadingEntityTags[entity][0]) || loadingUnits || loadingAccounts) &&
                            <LinearProgress color="primary" />
                        }

                        {renderLevel(0)}
                    </div>
            }

            {
                (showSelectedItemsBelow && !onlyValueId) &&
                <div style={{ marginTop: 15 }}>
                    {
                        value && value?.length > 0 &&
                        value?.map((item, key) => {
                            return (
                                < Chip
                                    label={item?.label}
                                    handleDelete={() => {
                                        let newSelected = value.filter(v => {
                                            if (v?.id == item.id && v?.name == item.name) {
                                                return false;
                                            }
                                            return true;
                                        });
                                        if (props.onChange) props.onChange(newSelected, entity);
                                    }}
                                    key={key}
                                />
                            )
                        })
                    }
                </div>
            }
        </div>
    )
};

export default EntityTagPicker;